export var getSrcWithParameters = function getSrcWithParameters(src, options) {
  var urlParameters = [""];
  var dpr = options.dpr || 1;

  if (options.fit === "crop" && options.width && options.height) {
    var width = options.width * dpr;
    var height = options.height * dpr;
    urlParameters.push("c_" + width + "_" + height);
  }

  if (options.fit === "cover" && options.width && options.height) {
    var width = options.width * dpr;
    var height = options.height * dpr;
    urlParameters.push("cx_" + width + "_" + height);
  }

  if (options.fit === "contain") {
    var width = options.width ? options.width * dpr : "x";
    var height = options.height ? options.height * dpr : "x";
    urlParameters.push("rx_" + width + "_" + height);
  }

  if (options.fit === "scale-down") {
    var width = options.width ? options.width * dpr : "x";
    var height = options.height ? options.height * dpr : "x";
    urlParameters.push("r_" + width + "_" + height);
  }

  var urlParametersStr = urlParameters.join("/") || "";
  return "" + src + urlParametersStr;
};